module.exports = __webpack_public_path__ + "img/pr-3.ee8b55b3.png";